import React from 'react';

import Filters from 'components/shared/Filters/Filters';

const CustomReportFilters = ({ filters, setFilters, defaultFilters }) => {
  return (
    <div className="w-full max-w-[500px]">
      <Filters filters={filters} setFilters={setFilters} defaultFilters={defaultFilters} />
    </div>
  );
};

export default CustomReportFilters;
